module.exports = __webpack_public_path__ + "d7525655f4aab6388eaaf593b01c6406.png";